export const COLLECTION = {
  CAREER: 'career',
  PROJECT: 'project',
};

export const PATH = {
  intro: '/',
  project: `/${COLLECTION.PROJECT}/:title`,
};

export const ICON_COLLOR = {
  github: 'black',
  velog: '#20c997',
};

export const MAX_DOWNLOAD_SIZE_BYTES = 1024 * 1024;

export const LOCAL_STORAGE_KEY = {
  LANGUAGE: 'lang',
};
